import { createFileRoute } from "@tanstack/react-router";
import OrderEditClient from "@/components/logistics/orders/order-edit-client";

export const Route = createFileRoute(
  "/_authenticated/logistics/orders/$id/edit",
)({
  component: OrderEditPage,
});

function OrderEditPage() {
  const { id } = Route.useParams();

  return <OrderEditClient id={id} />;
}
